<div class="root-div">
  <div class="flex-header-create">
    <button
      mat-raised-button
      class="create-button"
      color="primary"
      (mouseover)="mouseoverCreate = true"
      (mouseout)="mouseoverCreate = false"
      [style.opacity]="mouseoverCreate ? 0.7 : 1"
      pTooltip="Create a new Item"
      tooltipPosition="bottom"
      [matMenuTriggerFor]="typeMenu.menu">
      Create
    </button>

    <app-node-type-menu #typeMenu [nodeTypes]="nodeTypes" (typeSelected)="onNodeCreate($event)"></app-node-type-menu>
  </div>
</div>
